import React from 'react';

import styled from 'styled-components';

const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';
import { useContextSelector } from 'use-context-selector';
import { ModalProps } from '../Modal';
import ContainerModal from '../ContainerModal';
import Button from '../Button';
import { PlatformContext } from '../../contexts/PlatformContext';
import { RouterContext, useRouter } from '../../contexts/RouterContext';
import { Page, useMainRouter } from '../../Router/pageComponents';
import { FirebaseEvents } from '../../utils/enums/firebase-events';
import { useAnalytics } from '../../hooks/useAnalytics';
import { useScheduleContext } from '../../contexts/ScheduleContext';
import { useServiceContext } from '../../contexts/ServiceContext';
import { PAGES } from '../../flows/General/router/pages';

export type SystemUnavailableProps = Pick<ModalProps, 'visible' | 'onClose'>;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: #555658;

  img {
    width: 120px;
    height: 120px;
    align-self: center;
  }

  h3 {
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    margin-top: 24px;
  }

  div {
    margin-top: 24px;

    p {
      text-align: left;
      color: #898b8e;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 8px;
    }

    ul {
      margin-left: 24px;

      li {
        text-align: left;
        color: #898b8e;
        font-size: 16px;
        font-weight: 400;
      }
    }
  }

  .info {
    margin-top: 32px;
    font-size: 16px;
    font-weight: 500;
  }

  @media (min-width: 900px) {
    justify-content: space-between;
  }
`;

const SystemUnavailable: React.FC<SystemUnavailableProps> = ({ visible, onClose }) => {
  const { clearData, setIsSchedulerOpen } = useContextSelector(PlatformContext, state => state);

  const { navigate } = useMainRouter();

  const { logEvent } = useAnalytics();
  const { selectedItem } = useScheduleContext();
  const { selectedService } = useServiceContext();
  const { route } = useRouter();

  const openConsultAppointment = () => {
    onClose();
    clearData();
    navigate(Page.CONSULT_APPOINTMENT);
  };

  React.useEffect(() => {
    if (visible)
      logEvent({
        eventName: FirebaseEvents.schedule_unavailable_service,
        eventParams: {
          product_id: selectedItem?.productId,
          product_name: selectedItem?.productName,
          service_id: selectedService.id,
          service_name: selectedService.name,
          screen: PAGES[route]?.title
        }
      });
  }, [visible]);

  return (
    <ContainerModal
      visible={visible}
      onClose={onClose}
      withoutCloseButton={true}
      name="SystemUnavailable"
      childrenFooter={
        <>
          <Button disabled={!visible} type="button" title="Consultar agendamento" onClick={openConsultAppointment} />
          <Button disabled={!visible} type="button" title="Fechar" onClick={onClose} secondary />
        </>
      }
    >
      <Container>
        <img src={warningIcon} alt="warning" />
        <h3>Não foi possível realizar seu agendamento no momento</h3>

        <div>
          <p>Possíveis causas:</p>
          <ul>
            <li>Você já possui uma consulta agendada</li>
            <li>Sistema indisponível</li>
          </ul>
        </div>

        <p className="info">Para consultar ou cancelar seu agendamento, acesse:</p>
      </Container>
    </ContainerModal>
  );
};

export default SystemUnavailable;
